
















































































import { Component, Prop } from 'vue-property-decorator';

import TopBarMenu from '@/componentsV2/atoms/TopBarMenu/TopBarMenu.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import { FilledButton } from '@/components/molecules';
import Arrow from '@/components/icons/Arrow.vue';
import Loading from '@/components/icons/Loading.vue';

import { ENotificationStatus, INotification } from '@/models/notification';

import NotificationMenuItem from './NotificationMenuItem.vue';
import Trigger from '../Trigger/Trigger.vue';

@Component({
  components: {
    Picture,
    FilledButton,
    NotificationMenuItem,
    Arrow,
    Trigger,
    Loading
  }
})
export default class NotificationMenuDropdown extends TopBarMenu {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop() allNotifications!: INotification[];
  @Prop() notificationsInGroups!: any;
  @Prop({ default: false }) loading?: boolean;
  unreadFilter: boolean = false;

  get unreadNotification() {
    return this.allNotifications.filter(
      item => item.status !== ENotificationStatus.SEEN
    );
  }

  get groups() {
    return Object.keys(this.notificationsInGroups);
  }

  get tPrefix() {
    return 'menus.topbar.notificationMenuDrop';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  reloadNotification(props = {}) {
    this.$emit('reload', {
      ...props,
      query: {
        seen: true,
        status: this.unreadFilter ? 'new' : ''
      }
    });
  }

  clickSeenNotification() {
    this.$emit('seeAll');
  }

  clickFilter(value: boolean) {
    this.unreadFilter = value;

    this.$emit('reload', {
      clearList: true,
      query: {
        status: this.unreadFilter ? 'new' : ''
      }
    });
  }
}
